import { ReactNode } from 'react';
import { useUser } from '@/contexts/UserContext';
import LoginModal from './LoginModal';

interface AuthGuardProps {
  children: ReactNode;
}

export default function AuthGuard({ children }: AuthGuardProps) {
  const { isAuthenticated } = useUser();

  if (!isAuthenticated) {
    return <LoginModal />;
  }

  return <>{children}</>;
}
